import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const OnlineTrading = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="online-trading-page">
      <SEO
        title="Online Trading Platforms & Mobile App"
        description="Experience seamless online trading with Gateway Financial's advanced platforms. Trade in equity, derivatives, and commodities using our secure web and mobile applications."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: 'url("/images/online-trading-bg.jpg")',
              }}
            >
              <canvas id="canvas" aria-hidden="true" />
              <div className="carousel-caption">
                <h1>Online Trading</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <h2>Coming Soon!</h2>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="App Preview"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default OnlineTrading;
